import cciAxios from '@di-shared/api/cci/httpClient';
import {MeResponse, MyCarResponse, TokenExchangeParams, TokenExchangeResponse} from '@di-shared/api/cci/types';

export async function postAuthTokenExchange({serviceType, token}: TokenExchangeParams): Promise<TokenExchangeResponse> {
  const {data} = await cciAxios.post(
    `/v1/auth/token-exchange`,
    {},
    {
      params: {serviceType},
      headers: {
        'exchangeable-token': token,
      },
      cache: {ttl: 86400, interpretHeader: false},
    }
  );
  return data;
}

export async function getMe(): Promise<MeResponse> {
  const {data} = await cciAxios.get(`/v1/me`, {
    cache: {
      interpretHeader: false,
      ttl: 86400,
    },
  });
  return data;
}

export async function getMyCarDetail(vin: string): Promise<MyCarResponse> {
  const {data} = await cciAxios.get(`/v1/vehicle/detail?vin=${vin}`);
  return data;
}

export async function getMyCars(): Promise<{contents: Array<MyCarResponse>}> {
  const {data} = await cciAxios.get(`/v1/vehicle/available-vehicles`);
  return data;
}
